import type { Brand } from '~/types/user';

import { logoStyle } from './brandCell.css';

type Props = {
  brand: Brand;
};

export const BrandLogoCell = ({ brand }: Props) => {
  if (!brand.logo) return null;

  return <img alt={`Logo ${brand.companyName}`} className={logoStyle} src={brand.logo} />;
};
